module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_bft-49e6602449804ba04578981f9f18d345.png";